
import HomePage from '../pages/home.f7.html';
import CodigoPage from '../pages/codigo.f7.html';
import SairPage from '../pages/sair.f7.html';
import LoginPage from '../pages/login.f7.html';
import ResultadoHome from '../pages/resultado.f7.html';
import ListaHome from '../pages/lista.f7.html';
import NotFoundPage from '../pages/404.f7.html';

import $$ from 'dom7';
import $ from 'jquery';

var routes = [
{
    path: '/',
    component: LoginPage,
    on: {
        pageAfterIn: function test (e, page) {
          var token = this.app.data.db.getItem(this.app.id+".token");
          var app = this.app;

          console.log(token);

          if(token != undefined && token != null && token != "null")  {
            //app.views.main.router.navigate('/codigo/kHPD-9173/', {reloadCurrent: true,ignoreCache: true}); 
            app.views.main.router.navigate('/inicial/', {reloadCurrent: true,ignoreCache: true}); 
            return;
          }
          else {
            setTimeout(function() {
              app.views.main.router.navigate('/login/', {reloadCurrent: true,ignoreCache: true}); 
            }, 1000);
            
            return;
          }
        },
        pageInit: function test (e, page) {
           var app = this.app;
           console.log(this.app.methods)
          this.app.methods.ativarMascaras();
          
        }
      }    
  },
  {
    path: '/inicial/',
    component: HomePage,
    on: {
        pageInit: function test (e, page) {
          var app = this.app;
          $$(".versao-app").html(this.app.data.versao);
          var expositor = JSON.parse(app.data.db.getItem(this.app.id+".expositor"));
          $$(".expositornome").html("Autenticado como "+expositor.nome_fantasia);

        }
      } 
  },
  {
    path: '/sair/',
    component: SairPage,
  },
  {
    path: '/login/',
    component: LoginPage,
       on: {
        pageInit: function test (e, page) {
          var app = this.app;
          this.app.methods.ativarMascaras();
        }
      } 
  },
    {
    path: '/logout/',
    async: function (routeTo, routeFrom, resolve, reject) {
      var router = this;
      var app = router.app;
      app.data.db.removeItem(app.id+".expositor");
      app.data.db.removeItem(app.id+".token");
      app.preloader.hide();
      location.reload();
    },    
  },
  {
    path: '/codigo/:codigo/',
    async: function (routeTo, routeFrom, resolve, reject) {
      var router = this;
      var app = router.app;
      app.preloader.show();

      var codigo = routeTo.params.codigo;
      var tipo = "";
      var direcao = "";

      app.request({
       url: app.methods.request('/leitura'),
        dataType: 'json',
        method: 'GET',
        cache: false,
        crossDomain: true,
        data: {"codigo":codigo,"tipo":tipo,"direcao":direcao},
        success: function (data) {
          app.preloader.hide();
          if(data.success == true) {
          resolve(
  {
    component: ResultadoHome,
  },
  {
    context: {
      codigo: codigo,
      mensagem: data.mensagem,
      mensagem2: data.mensagem2 ? data.mensagem2 : "",
      necessidade: data.necessidade ? data.necessidade : "",
      necessidadei: data.necessidadei ? data.necessidadei : "",
      evento: data.evento,
      ingresso: data.ingresso,
      css: data.css,
      class: data.class,
    }
  }
);

          } else {
              var notificationFull = app.notification.create({
              icon: '<i class="fas fa-exclamation-triangle"></i>',
              title: 'ATENÇÃO',
              text: data.erro,
              closeTimeout: 3000,
            });

            notificationFull.open();
          }
        }
    });      

       
    },
  }, 
  {
    path: '/leituras/',
    async: function (routeTo, routeFrom, resolve, reject) {
      var router = this;
      var app = router.app;
      app.preloader.show();

      var codigo = routeTo.params.codigo;
      var tipo = "";
      var direcao = "";

      app.request({
       url: app.methods.request('/leituras'),
        dataType: 'json',
        method: 'GET',
        cache: false,
        crossDomain: true,
        data: {"codigo":codigo,"tipo":tipo,"direcao":direcao},
        success: function (data) {
          app.preloader.hide();
          if(data.success == true) {
          resolve(
              {
                component: ListaHome,
              },
              {
                context: {
                  leituras:data.leituras,
                  link_exportacao:data.link_exportacao,
                  
                }
              }
          ); 

          } else {
              var notificationFull = app.notification.create({
              icon: '<i class="fas fa-exclamation-triangle"></i>',
              title: 'ATENÇÃO',
              text: data.erro,
              closeTimeout: 3000,
            });

            notificationFull.open();
          }
        }
    });      

       
    },
  },  
   {
    path: '/codigo/',
    async: function (routeTo, routeFrom, resolve, reject) {
      var router = this;
      var app = router.app;
      resolve(
          {
            component: CodigoPage,
          }
        );
      setTimeout(function() {
         app.methods.ativarMascaras();
      }, 500);
       
    },    
  },
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;